import styled from 'styled-components'

export const TextEllipsis = styled.div<{ $lineClamp: number }>`
  display: -webkit-box;
  -webkit-line-clamp: ${({ $lineClamp }) => $lineClamp};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`
